/**
 * SITE FOOTER
 *
 * @returns {Promise<void>}
 */
const siteFooter = async () => {
    const [
        {default: Vue},
        { BCollapse },
        { VBToggle }
    ] = await Promise.all([
        import(/* webpackChunkName: "vue" */ 'vue'),
        import(/* webpackChunkName: "bs-collapse" */ 'bootstrap-vue'),
        import(/* webpackChunkName: "bs-toggle" */ 'bootstrap-vue'),
    ]);

    Vue.directive('b-toggle', VBToggle);

    // Create our vue instance
    const vm = new Vue({
        name: 'SiteFooter',
        el: '#site-footer',
        delimiters: ['[[', ']]'],
        components: {
            'b-collapse': BCollapse,
        }
    });

    return vm;
};

// Execute async function
siteFooter().then( (vm) => {
});